// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ReviewAiSuggestionsFromNotification_Kgv2NodeResolvedFragment = { __typename?: 'KGV2Node', id: string, namePrimary: string, resolvedEntities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null> | null }, resolvedClientProfiles: { __typename?: 'ClientProfileConnection', edges?: Array<{ __typename?: 'ClientProfileEdge', node?: { __typename?: 'ClientProfile', id: string, displayName: string } | null } | null> | null }, resolvedClientOrganizations: { __typename?: 'ClientOrganizationConnection', edges?: Array<{ __typename?: 'ClientOrganizationEdge', node?: { __typename?: 'ClientOrganization', id: string, name: string } | null } | null> | null }, resolvedTestamentaryEntities: { __typename?: 'TestamentaryEntityConnection', edges?: Array<{ __typename?: 'TestamentaryEntityEdge', node?: { __typename?: 'TestamentaryEntity', id: string, displayName: string } | null } | null> | null } };

export type ReviewAiSuggestionsFromNotification_Kgv2StatementWithNodesFragment = { __typename?: 'KGV2Statement', id: string, predicate: string, subject: (
    { __typename?: 'KGV2Node' }
    & ReviewAiSuggestionsFromNotification_Kgv2NodeResolvedFragment
  ), object?: (
    { __typename?: 'KGV2Node' }
    & ReviewAiSuggestionsFromNotification_Kgv2NodeResolvedFragment
  ) | null };

export type ReviewAiSuggestionsFromNotification_AiSuggestionFragment = { __typename?: 'AISuggestion', id: string, kind: Types.AiSuggestionKind, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null, onboardingEntity?: { __typename?: 'OnboardingEntitySuggestion', entityKind?: Types.EntityKind | null } | null, sourceKgV2Nodes: { __typename?: 'KGV2NodeConnection', edges?: Array<{ __typename?: 'KGV2NodeEdge', node?: { __typename?: 'KGV2Node', id: string } | null } | null> | null }, kgV2Statements: { __typename?: 'KGV2StatementConnection', edges?: Array<{ __typename?: 'KGV2StatementEdge', node?: (
        { __typename?: 'KGV2Statement' }
        & ReviewAiSuggestionsFromNotification_Kgv2StatementWithNodesFragment
      ) | null } | null> | null } };

export type ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ReviewAiSuggestionsFromNotificationSuggestionsV2Query = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & ReviewAiSuggestionsFromNotification_AiSuggestionFragment
      ) | null } | null> | null } };

export type ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ReviewAiSuggestionsFromNotificationAutoAcceptedQuery = { __typename?: 'Query', aiSuggestions: { __typename?: 'AISuggestionConnection', edges?: Array<{ __typename?: 'AISuggestionEdge', node?: (
        { __typename?: 'AISuggestion' }
        & ReviewAiSuggestionsFromNotification_AiSuggestionFragment
      ) | null } | null> | null } };

export type ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables = Types.Exact<{
  householdId: Types.Scalars['ID']['input'];
}>;


export type ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, displayName: string } | null } | null> | null } };

export const Operations = {
  Query: {
    ReviewAISuggestionsFromNotificationSuggestionsV2: 'ReviewAISuggestionsFromNotificationSuggestionsV2' as const,
    ReviewAISuggestionsFromNotificationAutoAccepted: 'ReviewAISuggestionsFromNotificationAutoAccepted' as const,
    ReviewAISuggestionsFromNotificationHouseholdMetadata: 'ReviewAISuggestionsFromNotificationHouseholdMetadata' as const
  },
  Fragment: {
    ReviewAISuggestionsFromNotification_KGV2NodeResolved: 'ReviewAISuggestionsFromNotification_KGV2NodeResolved' as const,
    ReviewAISuggestionsFromNotification_KGV2StatementWithNodes: 'ReviewAISuggestionsFromNotification_KGV2StatementWithNodes' as const,
    ReviewAISuggestionsFromNotification_AiSuggestion: 'ReviewAISuggestionsFromNotification_AiSuggestion' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ReviewAiSuggestionsFromNotification_Kgv2NodeResolvedFragmentDoc = gql`
    fragment ReviewAISuggestionsFromNotification_KGV2NodeResolved on KGV2Node {
  id
  namePrimary
  resolvedEntities {
    edges {
      node {
        id
        kind
        subtype {
          id
          displayName
        }
      }
    }
  }
  resolvedClientProfiles {
    edges {
      node {
        id
        displayName
      }
    }
  }
  resolvedClientOrganizations {
    edges {
      node {
        id
        name
      }
    }
  }
  resolvedTestamentaryEntities {
    edges {
      node {
        id
        displayName
      }
    }
  }
}
    `;
export const ReviewAiSuggestionsFromNotification_Kgv2StatementWithNodesFragmentDoc = gql`
    fragment ReviewAISuggestionsFromNotification_KGV2StatementWithNodes on KGV2Statement {
  id
  predicate
  subject {
    ...ReviewAISuggestionsFromNotification_KGV2NodeResolved
  }
  object {
    ...ReviewAISuggestionsFromNotification_KGV2NodeResolved
  }
}
    ${ReviewAiSuggestionsFromNotification_Kgv2NodeResolvedFragmentDoc}`;
export const ReviewAiSuggestionsFromNotification_AiSuggestionFragmentDoc = gql`
    fragment ReviewAISuggestionsFromNotification_AiSuggestion on AISuggestion {
  id
  kind
  acceptanceStatus
  onboardingEntity {
    entityKind
  }
  sourceKgV2Nodes {
    edges {
      node {
        id
      }
    }
  }
  kgV2Statements {
    edges {
      node {
        ...ReviewAISuggestionsFromNotification_KGV2StatementWithNodes
      }
    }
  }
}
    ${ReviewAiSuggestionsFromNotification_Kgv2StatementWithNodesFragmentDoc}`;
export const ReviewAiSuggestionsFromNotificationSuggestionsV2Document = gql`
    query ReviewAISuggestionsFromNotificationSuggestionsV2($householdId: ID!) {
  aiSuggestions(
    where: {hasHouseholdWith: [{id: $householdId}], acceptanceStatusIsNil: true, kindIn: [ONBOARDING_ENTITY, ONBOARDING_TESTAMENTARY_ENTITY, ASSET, LIABILITY, LIFE_INSURANCE]}
    orderBy: {field: created_at, direction: DESC}
  ) {
    edges {
      node {
        ...ReviewAISuggestionsFromNotification_AiSuggestion
      }
    }
  }
}
    ${ReviewAiSuggestionsFromNotification_AiSuggestionFragmentDoc}`;

/**
 * __useReviewAiSuggestionsFromNotificationSuggestionsV2Query__
 *
 * To run a query within a React component, call `useReviewAiSuggestionsFromNotificationSuggestionsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useReviewAiSuggestionsFromNotificationSuggestionsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewAiSuggestionsFromNotificationSuggestionsV2Query({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useReviewAiSuggestionsFromNotificationSuggestionsV2Query(baseOptions: Apollo.QueryHookOptions<ReviewAiSuggestionsFromNotificationSuggestionsV2Query, ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewAiSuggestionsFromNotificationSuggestionsV2Query, ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables>(ReviewAiSuggestionsFromNotificationSuggestionsV2Document, withFetchPolicyContext(options));
      }
export function useReviewAiSuggestionsFromNotificationSuggestionsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewAiSuggestionsFromNotificationSuggestionsV2Query, ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewAiSuggestionsFromNotificationSuggestionsV2Query, ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables>(ReviewAiSuggestionsFromNotificationSuggestionsV2Document, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useReviewAiSuggestionsFromNotificationSuggestionsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewAiSuggestionsFromNotificationSuggestionsV2Query, ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewAiSuggestionsFromNotificationSuggestionsV2Query, ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables>(ReviewAiSuggestionsFromNotificationSuggestionsV2Document, withFetchPolicyContext(options));
        }
export type ReviewAiSuggestionsFromNotificationSuggestionsV2QueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationSuggestionsV2Query>;
export type ReviewAiSuggestionsFromNotificationSuggestionsV2LazyQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationSuggestionsV2LazyQuery>;
export type ReviewAiSuggestionsFromNotificationSuggestionsV2SuspenseQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationSuggestionsV2SuspenseQuery>;
export type ReviewAiSuggestionsFromNotificationSuggestionsV2QueryResult = Apollo.QueryResult<ReviewAiSuggestionsFromNotificationSuggestionsV2Query, ReviewAiSuggestionsFromNotificationSuggestionsV2QueryVariables>;
export const ReviewAiSuggestionsFromNotificationAutoAcceptedDocument = gql`
    query ReviewAISuggestionsFromNotificationAutoAccepted($householdId: ID!) {
  aiSuggestions(
    where: {hasHouseholdWith: [{id: $householdId}], acceptanceStatusIn: [AUTO_ACCEPTED], kindIn: [ONBOARDING_ENTITY, ONBOARDING_TESTAMENTARY_ENTITY, ONBOARDING_INDIVIDUAL, ONBOARDING_ORGANIZATION, ASSET, LIABILITY, LIFE_INSURANCE]}
  ) {
    edges {
      node {
        ...ReviewAISuggestionsFromNotification_AiSuggestion
      }
    }
  }
}
    ${ReviewAiSuggestionsFromNotification_AiSuggestionFragmentDoc}`;

/**
 * __useReviewAiSuggestionsFromNotificationAutoAcceptedQuery__
 *
 * To run a query within a React component, call `useReviewAiSuggestionsFromNotificationAutoAcceptedQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewAiSuggestionsFromNotificationAutoAcceptedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewAiSuggestionsFromNotificationAutoAcceptedQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useReviewAiSuggestionsFromNotificationAutoAcceptedQuery(baseOptions: Apollo.QueryHookOptions<ReviewAiSuggestionsFromNotificationAutoAcceptedQuery, ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewAiSuggestionsFromNotificationAutoAcceptedQuery, ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables>(ReviewAiSuggestionsFromNotificationAutoAcceptedDocument, withFetchPolicyContext(options));
      }
export function useReviewAiSuggestionsFromNotificationAutoAcceptedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewAiSuggestionsFromNotificationAutoAcceptedQuery, ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewAiSuggestionsFromNotificationAutoAcceptedQuery, ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables>(ReviewAiSuggestionsFromNotificationAutoAcceptedDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useReviewAiSuggestionsFromNotificationAutoAcceptedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewAiSuggestionsFromNotificationAutoAcceptedQuery, ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewAiSuggestionsFromNotificationAutoAcceptedQuery, ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables>(ReviewAiSuggestionsFromNotificationAutoAcceptedDocument, withFetchPolicyContext(options));
        }
export type ReviewAiSuggestionsFromNotificationAutoAcceptedQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationAutoAcceptedQuery>;
export type ReviewAiSuggestionsFromNotificationAutoAcceptedLazyQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationAutoAcceptedLazyQuery>;
export type ReviewAiSuggestionsFromNotificationAutoAcceptedSuspenseQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationAutoAcceptedSuspenseQuery>;
export type ReviewAiSuggestionsFromNotificationAutoAcceptedQueryResult = Apollo.QueryResult<ReviewAiSuggestionsFromNotificationAutoAcceptedQuery, ReviewAiSuggestionsFromNotificationAutoAcceptedQueryVariables>;
export const ReviewAiSuggestionsFromNotificationHouseholdMetadataDocument = gql`
    query ReviewAISuggestionsFromNotificationHouseholdMetadata($householdId: ID!) {
  households(where: {id: $householdId}) {
    edges {
      node {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useReviewAiSuggestionsFromNotificationHouseholdMetadataQuery__
 *
 * To run a query within a React component, call `useReviewAiSuggestionsFromNotificationHouseholdMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewAiSuggestionsFromNotificationHouseholdMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewAiSuggestionsFromNotificationHouseholdMetadataQuery({
 *   variables: {
 *      householdId: // value for 'householdId'
 *   },
 * });
 */
export function useReviewAiSuggestionsFromNotificationHouseholdMetadataQuery(baseOptions: Apollo.QueryHookOptions<ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery, ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery, ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables>(ReviewAiSuggestionsFromNotificationHouseholdMetadataDocument, withFetchPolicyContext(options));
      }
export function useReviewAiSuggestionsFromNotificationHouseholdMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery, ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery, ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables>(ReviewAiSuggestionsFromNotificationHouseholdMetadataDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useReviewAiSuggestionsFromNotificationHouseholdMetadataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery, ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery, ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables>(ReviewAiSuggestionsFromNotificationHouseholdMetadataDocument, withFetchPolicyContext(options));
        }
export type ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationHouseholdMetadataQuery>;
export type ReviewAiSuggestionsFromNotificationHouseholdMetadataLazyQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationHouseholdMetadataLazyQuery>;
export type ReviewAiSuggestionsFromNotificationHouseholdMetadataSuspenseQueryHookResult = ReturnType<typeof useReviewAiSuggestionsFromNotificationHouseholdMetadataSuspenseQuery>;
export type ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryResult = Apollo.QueryResult<ReviewAiSuggestionsFromNotificationHouseholdMetadataQuery, ReviewAiSuggestionsFromNotificationHouseholdMetadataQueryVariables>;